import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../shared/services/auth.service';
import { AppService } from '../shared/services/app.service';
import { NotifyService } from '../shared/services/notify.service';

import { INotification } from '../shared/interfaces/notification';

@Component({
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit {
  

  constructor(
      private _appService: AppService,
      private _authService: AuthService,
      private _notifyService: NotifyService,
      private _router: Router
    ) {
    this._appService.showLoader();
  }

  ngOnInit() {
    if(this._authService.clearToken()) {
        const note: INotification = {
            styleClass: 'alert-info',
            heading:'',
            body: 'You have been signed out.'
        }
        this._notifyService.setNote(note);
        var that = this;
        setTimeout(function() {
          that._router.navigateByUrl('/login');
        }, 2000);
        
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/logout.component.ts